import React from "react";
import { Link, useParams } from "react-router-dom";
import { CheckCircle2, MessageCircle, ArrowLeft } from "lucide-react";
import { useSettings } from "../context/SettingsContext";

function normalizeWa(raw) {
    if (!raw) return null;
    let s = String(raw).replace(/[^\d+]/g, "");
    if (s.startsWith("+")) s = s.slice(1);
    if (s.startsWith("0")) s = "62" + s.slice(1);
    if (!s.startsWith("62")) s = "62" + s;
    return /^\d{9,15}$/.test(s) ? s : null;
}

export default function CheckoutSuccess() {
    const { orderNo } = useParams();
    const { settings } = useSettings();
    const phone = normalizeWa(settings?.whatsapp_number);
    const text = encodeURIComponent(
        `Halo ${settings?.name || "Toko"}, saya baru saja membuat order *${orderNo}*. Mohon konfirmasinya. Terima kasih!`,
    );
    const waUrl = phone ? `https://wa.me/${phone}?text=${text}` : null;

    return (
        <div data-testid="checkout-success-page" className="mx-auto max-w-md px-5 py-16 text-center">
            <div className="mx-auto h-20 w-20 grid place-items-center rounded-full bg-accent/15">
                <CheckCircle2 size={44} className="text-accent" strokeWidth={2} />
            </div>
            <h1 className="mt-5 font-heading text-3xl font-semibold tracking-tight">Order Berhasil Dikirim!</h1>
            <p className="mt-2 text-sm text-muted-foreground">
                Nomor order Anda: <strong className="text-foreground" data-testid="success-order-no">{orderNo}</strong>
            </p>
            <p className="mt-4 text-sm">
                Admin sudah menerima notifikasi. Untuk percepat konfirmasi, hubungi langsung via WhatsApp di bawah ini.
            </p>

            <div className="mt-8 flex flex-col gap-2">
                {waUrl && (
                    <a
                        href={waUrl}
                        target="_blank"
                        rel="noreferrer"
                        data-testid="success-wa-btn"
                        className="inline-flex items-center justify-center gap-2 rounded-full bg-[#25D366] px-6 py-3 text-sm font-semibold text-white hover:opacity-90"
                    >
                        <MessageCircle size={16} strokeWidth={2} fill="white" stroke="#25D366" /> Chat Admin via WhatsApp
                    </a>
                )}
                <Link
                    to="/"
                    data-testid="success-back-link"
                    className="inline-flex items-center justify-center gap-2 rounded-full border border-border bg-white px-6 py-3 text-sm hover:bg-secondary"
                >
                    <ArrowLeft size={14} /> Kembali ke Katalog
                </Link>
            </div>
        </div>
    );
}
